import { EventEmitter } from '@angular/core';
import { NavbarProvider } from '../interfaces/navbar-provider.interface';

/**
 * Minimaler NavbarProvider mit funktionalem Command-Bus.
 * Für Apps ohne komplexe Navbar-Steuerung.
 */
export class SimpleNavbarProvider implements NavbarProvider {
	title = '';
	componentTitle = '';
	events = new Map<number, EventEmitter<any>>();

	private activeCommands = new Set<number>();

	clear(): void {
		this.activeCommands.clear();
	}

	activate(command: number): void {
		this.activeCommands.add(command);
		this.command(command).emit();
	}

	isActive(command: number): boolean {
		return this.activeCommands.has(command);
	}

	subscribe<T>(command: number, callback: (p: T) => void): void {
		this.command(command).subscribe(callback);
	}

	unsubscribe(command: number): void {
		this.events.delete(command);
	}

	command(command: number): EventEmitter<any> {
		if (!this.events.has(command)) {
			this.events.set(command, new EventEmitter<any>());
		}
		return this.events.get(command)!;
	}

	getTitle(): string {
		return this.title;
	}
}
